import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';



@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token: string | null = null;
    
    // Determine which token to use based on the request URL or headers
    if (request.url.includes('/api/v1/customer')) {
      token = `${(window as any).customerInfo.api_token}`;
    } else {
      token = `${(window as any).userInfo.api_token}`;
    }

    request = request.clone({
      setHeaders: {
        // Authorization: `Bearer ${(window as any).userInfo.api_token}`,
        Authorization: `Bearer ${token}`,
        'Accept': 'application/json'
      }
    });

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.status === 401) {
          // window.location.reload();
        }
        return throwError(error);
      })
    );

  }
}